<div class="house-card">
    <div
        class="card-header"
        (click)="openHouseDetails()"
        style="cursor: pointer"
    >
        <h3 class="house-name">{{ house.name }}</h3>
        <div class="alerts">
            <span class="alert-count critical">{{
                house.alerts.critical
            }}</span>
            <span class="alert-count warning">{{ house.alerts.warning }}</span>
            <span class="alert-count info">{{ house.alerts.info }}</span>
            <button
                class="expand-btn"
                (click)="$event.stopPropagation(); toggleExpand()"
            >
                <span [class.rotated]="expanded">▾</span>
            </button>
        </div>
    </div>

    <div class="card-body" *ngIf="expanded">
        <div class="stats-grid">
            <div class="stat-item">
                <div class="stat-title">Humidity</div>
                <div class="stat-value-container">
                    <img
                        src="/assets/img/dashboard-farm-overview/humidity-icon.svg"
                        alt=""
                        class="stat-icon"
                    />
                    <span class="stat-value"
                        >{{ house?.humidity | number: '1.1-2' }}%</span
                    >
                </div>
            </div>
            <div class="stat-item">
                <div class="stat-title">Temperature</div>
                <div class="stat-value-container">
                    <img
                        src="/assets/img/dashboard-farm-overview/thermometer-icon.svg"
                        alt=""
                        class="stat-icon"
                    />
                    <span class="stat-value"
                        >{{ house?.temperatureC | number: '1.1-2' }} °C</span
                    >
                </div>
            </div>
            <div class="stat-item">
                <div class="stat-title">CO2</div>
                <div class="stat-value-container">
                    <img
                        src="/assets/img/dashboard-farm-overview/co2-icon.svg"
                        alt=""
                        class="stat-icon"
                    />
                    <span class="stat-value"
                        >{{ house?.co2 | number: '1.1-2' }} ppm</span
                    >
                </div>
            </div>
            <div class="stat-item">
                <div class="stat-title">Number of Chicks</div>
                <div class="stat-value-container">
                    <img
                        src="/assets/img/dashboard-farm-overview/chick-icon.svg"
                        alt=""
                        class="stat-icon"
                    />
                    <span class="stat-value">{{ house?.chicks }}</span>
                </div>
            </div>
            <div class="stat-item">
                <div class="stat-title">Partitions</div>
                <div class="stat-value-container">
                    <img
                        src="/assets/img/dashboard-farm-overview/partition-icon.svg"
                        alt=""
                        class="stat-icon"
                    />
                    <span class="stat-value">{{ house?.partitions }}</span>
                </div>
            </div>
        </div>

        <!-- <div class="partitions-section">

            <div class="stat-title">Daily Water Consumption</div>
                <div class="stat-value-container">
                    <span class="stat-value">{{ house?.dailyWaterConsumption }}</span>
                </div>
            
            <div class="stat-title">Cycle Water Consumption</div>
                <div class="stat-value-container">
                    <span class="stat-value">{{ house?.cycleWaterConsumption }}</span>
                </div>

                <div class="stat-title">Feed Consumption</div>
                <div class="stat-value-container">
                    <span class="stat-value">{{ house?.feedConsumption }}</span>
                </div>
          
        </div> -->

        <hr class="section-divider" />

<div class="consumption-grid">
    <div class="stat-item">
        <div class="stat-title">Daily Water Consumption</div>
        <div class="stat-value-container">
            <span class="stat-value">{{ house.dailyWaterConsumption }}</span>
        </div>
    </div>

    <div class="stat-item">
        <div class="stat-title">Cycle Water Consumption</div>
        <div class="stat-value-container">
            <span class="stat-value">{{ house.cycleWaterConsumption }}</span>
        </div>
    </div>

    <div class="stat-item">
        <div class="stat-title">Feed Consumption</div>
        <div class="stat-value-container">
            <span class="stat-value">{{ house.feedConsumption }}</span>
        </div>
    </div>
    <div class="stat-item">
        <div class="stat-title">Feed Remaining</div>
        <div class="stat-value-container">
            <span class="stat-value">{{ house.feedRemaining }}</span>
        </div>
    </div>
</div>
    </div>
</div>
